import { defineComponent, renderSlot, watch } from 'vue'
import { provideGlobalConfig } from './hooks/use-global-config'
import { configProviderProps } from './config-provider-props'

import type { MessageConfigContext } from '@jdesign-vue/components/message'

export const messageConfig: MessageConfigContext = {}
export const loadingConfig: {
  background?: string
  svgColor?: string
  textColor?: string
} = {}
export const drawerConfig: {
  titleSize?: string
} = {}

const ConfigProvider = defineComponent({
  name: 'JdConfigProvider',
  props: configProviderProps,

  setup(props, { slots }) {
    watch(
      () => props.message,
      (val) => {
        Object.assign(messageConfig, val ?? {})
      },
      { immediate: true, deep: true }
    )
    watch(
      () => props.loading,
      (val) => {
        Object.assign(loadingConfig, val ?? {})
      },
      { immediate: true, deep: true }
    )
    watch(
      () => props.drawer,
      (val) => {
        Object.assign(drawerConfig, val ?? {})
      },
      { immediate: true, deep: true }
    )
    const config = provideGlobalConfig(props)
    return () => renderSlot(slots, 'default', { config: config?.value })
  },
})
export type ConfigProviderInstance = InstanceType<typeof ConfigProvider>

export default ConfigProvider
